// import { accordion } from "./_accordion";
import { animation } from "./_animation";
import { common } from "./_common";
import { drawer } from "./_drawer";
import { slide } from "./_slide";
import { modal } from "./_modal";
import { video01 } from "./_video01";
import { headerMv } from "./_headerMv";
// import { test } from "./_test";
// import { tab } from "./_tab";

// accordion();
animation();
headerMv();
common();
drawer();
slide();
modal();
// test();
// tab();
video01();